import logoutPlaceholder from '../../hooks/logoutPlaceholder.js';

const apiEndPoint = process.env.REACT_APP_FETCH_URL;

export const getUserData = async ({ logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/info/user`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            return await response.json();
        }
        catch (error) {
            throw new Error(`Failed parsing user data: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not load user data: ${response.statusText}`);
};

/* Live userOverride snippet of the logged-in user, any failure means no override */
export const getUserOverride = async () => {
    try {
        const response = await fetch(`${apiEndPoint}/api/live/snippet/own/userOverride`, {
            mode: "cors",
            credentials: "include"
        });
        if(!response.ok) {
            return null;
        }
        const { snippets } = await response.json();
        return snippets?.[0] ?? null;
    }
    catch (error) {
        console.error(`Getting user override failed, ${error}`);
        return null;
    }
};
